import { GET_AVAILABLE_COUNTERS, SET_COUNTER_AIRLINES, SET_USER_COUNTER } from './actionTypes';

import { baseUrl } from '../../api/baseUrl';
import Counter from '../../models/Counter';

function getCounters(counters: Array<Counter>) {
  return {
    type: GET_AVAILABLE_COUNTERS,
    data: counters
  }
}

function setCounter(counter: any) {
  return {
    type: SET_USER_COUNTER,
    data: counter
  }
}

function setCounterAirlines(airlines: string[]) {
  return {
    type: SET_COUNTER_AIRLINES,
    data: airlines
  }
}


function setAirlinesAction(airlines: string[]) {

  return (dispatch: any) => {

    dispatch(setCounterAirlines(airlines));
  };
}

function setCounterAction(counterId: number) {

  return (dispatch: any) => {

    dispatch(setCounter(counterId));
  };
}

function receiveCounters() {

  return (dispatch: any) => {

    const counters = new EventSource(baseUrl + `counters`, {
      withCredentials: true
    });



    counters.onmessage = (event) => {

      const parsedData = JSON.parse(event.data);
      if (parsedData) {
        dispatch(getCounters(parsedData));
      }

    }

    counters.onerror = (error: any) => {

      if (error.type === 'error') {

      }

    }
  };
}

export {
  receiveCounters,
  setCounterAction,
  setAirlinesAction
}